import { useUISize } from 'app/utils/web-helpers';
import { GuidelinesScreen as GuidelinesScreenSmall } from './guidelines.small';
import { GuidelinesScreen as GuidelinesScreenLarge } from './guidelines.large';

export const GuidelinesScreen: typeof GuidelinesScreenSmall = (props) => {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return <GuidelinesScreenSmall {...props} />;
  }
  return <GuidelinesScreenLarge {...props} />;
};
